import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

export const Copyright = (props) => {
  return (
    <Typography variant="body2" color="rgba(232,240,254,0.2)" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://fidelize.org/">
        Algorithm Solutions
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
};
